
function Marquee(){
    return(
        <>
      <div
  style={{
    width: "100%",
    background: "#bb891c",
    overflow: "hidden",
    whiteSpace: "nowrap",
    position: "relative",
    padding: "10px 0",
    zIndex: 999,
  }}
>
  <div
    style={{
      display: "inline-block",
      color: "#fff",
      fontSize: "18px",
      fontWeight: "600",
      paddingLeft: "100%",
      animation: "scrollText 18s linear infinite",
    }}
  >
 <i className="fa fa-gift" style={{ marginRight: "10px" }}></i>
    Great Interior Design Offers
    &nbsp;&nbsp;&nbsp;

    <i className="fa fa-money" style={{ marginRight: "10px" }}></i>
    EMI Facility Available
    &nbsp;&nbsp;&nbsp;

    <i className="fa fa-home" style={{ marginRight: "10px" }}></i>
    Affordable Home Interior
    &nbsp;&nbsp;&nbsp;

    <i className="fa fa-star" style={{ marginRight: "10px" }}></i>
    Luxury Design at Best Price
    &nbsp;&nbsp;&nbsp;

    <i className="fa fa-users" style={{ marginRight: "10px" }}></i>
    Refer & Earn 
    &nbsp;&nbsp;&nbsp;

    <i className="fa fa-phone" style={{ marginRight: "10px" }}></i>
    Contact Now  </div>

  <style>
    {`
      @keyframes scrollText {
        0% {
          transform: translateX(0);
        }
        100% {
          transform: translateX(-100%);
        }
      }
    `}
  </style>
</div>
        
        </>
    )


}

export default Marquee;